var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavlogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "169.22pt",
    height: "154.88pt",
    viewBox: "0 0 169.22 154.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75 151 L 78 151 L 78 154.878906 L 75 154.878906 Z M 75 151 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80 87 L 169.21875 87 L 169.21875 91 L 80 91 Z M 80 87 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 147 147 L 157 147 L 157 154.878906 L 147 154.878906 Z M 147 147 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 84.605469 9.042969 L 72.703125 9.105469 L 72.703125 13.808594 L 84.605469 13.808594 Z M 84.605469 9.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 92.335938 14.382813 L 93.933594 7.945313 L 94.730469 8.011719 L 96.183594 14.382813 Z M 98.074219 0.46875 L 91.246094 0.46875 C 91.246094 0.46875 90.378906 0.710938 90.59375 1.140625 C 91.246094 2.671875 90.667969 3.039063 90.667969 3.039063 L 83.628906 23.144531 L 89.792969 23.144531 L 91.105469 18.546875 L 97.421875 18.546875 L 98.433594 23.085938 L 106.636719 23.085938 C 106.636719 23.085938 100.246094 3.78125 99.382813 1.507813 C 99.089844 0.527344 98.074219 0.46875 98.074219 0.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 147.144531 0.46875 L 129.578125 0.46875 L 129.578125 4.632813 L 138.441406 4.515625 L 129.289063 19.46875 L 129.289063 23.085938 L 146.566406 23.085938 L 146.632813 19.226563 L 137.710938 19.226563 L 147.144531 4.261719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 122.324219 12.238281 L 116.078125 0.46875 L 108.238281 0.46875 L 108.238281 23.144531 L 113.316406 23.144531 L 113.316406 10.578125 L 120 23.144531 L 127.472656 23.144531 L 127.472656 0.46875 L 122.324219 0.527344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 19.308594 18.175781 C 19.308594 18.855469 18.511719 19.777344 17.859375 20.082031 C 17.347656 20.265625 16.042969 20.265625 16.042969 20.265625 L 16.042969 23.640625 C 16.042969 23.640625 18.871094 23.820313 20.105469 23.699219 C 22.285156 23.515625 23.957031 22.84375 24.898438 21.675781 C 25.570313 20.882813 25.679688 19.054688 25.695313 19.25 C 25.625 16.21875 25.765625 0.402344 25.765625 0.402344 L 19.308594 0.402344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 64.460938 8.921875 C 62.867188 8.433594 60.976563 8.128906 59.886719 7.269531 C 58.074219 5.792969 60.105469 3.78125 62.210938 3.78125 C 64.679688 3.714844 67.945313 5.609375 67.945313 5.609375 L 67.945313 0.652344 C 67.945313 0.652344 66.132813 -0.207031 62.136719 0.0390625 C 58.507813 0.214844 54.730469 1.628906 53.421875 3.78125 C 52.410156 5.246094 51.902344 6.777344 52.410156 8.988281 C 53.066406 12.054688 55.898438 12.785156 58.945313 13.828125 C 59.09375 13.960938 63.15625 14.992188 63.953125 16.398438 C 64.320313 17.078125 64.023438 18.058594 63.664063 18.433594 C 62.210938 20.265625 58.21875 19.410156 56.328125 18.546875 C 55.460938 18.175781 54.730469 17.566406 54.003906 17.140625 C 53.5 16.773438 52.046875 15.847656 52.046875 15.847656 L 52.046875 21.792969 C 52.046875 21.792969 53.136719 22.589844 53.5 22.660156 C 56.476563 23.757813 63.226563 23.699219 65.761719 22.410156 C 68.382813 21.183594 70.488281 19.339844 70.847656 16.285156 C 71.429688 12.054688 68.085938 9.910156 64.460938 8.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 35.929688 14.382813 L 37.53125 7.945313 L 38.328125 8.066406 L 39.78125 14.382813 Z M 41.671875 0.46875 L 34.839844 0.46875 C 34.839844 0.46875 34.046875 0.710938 34.1875 1.140625 C 34.839844 2.730469 34.261719 3.039063 34.261719 3.039063 L 27.21875 23.144531 L 33.390625 23.144531 L 34.695313 18.546875 L 41.011719 18.546875 L 42.03125 23.085938 L 50.234375 23.085938 C 50.234375 23.085938 43.839844 3.78125 43.042969 1.507813 C 42.6875 0.527344 41.671875 0.46875 41.671875 0.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 145.726563 147.132813 L 147.960938 147.132813 L 147.960938 143.253906 L 145.726563 143.253906 Z M 145.726563 147.132813 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 75.652344 154.878906 L 77.875 154.878906 L 77.875 151.148438 L 75.652344 151.148438 Z M 75.652344 154.878906 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 75.652344 145.332031 L 77.875 145.332031 L 77.875 141.457031 L 75.652344 141.457031 Z M 75.652344 145.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 75.652344 135.644531 L 77.875 135.644531 L 77.875 131.761719 L 75.652344 131.761719 Z M 75.652344 135.644531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 75.652344 125.945313 L 77.875 125.945313 L 77.875 122.066406 L 75.652344 122.066406 Z M 75.652344 125.945313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 75.652344 116.257813 L 77.875 116.257813 L 77.875 112.378906 L 75.652344 112.378906 Z M 75.652344 116.257813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 75.652344 106.5625 L 77.875 106.5625 L 77.875 102.683594 L 75.652344 102.683594 Z M 75.652344 106.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 75.652344 96.875 L 77.875 96.875 L 77.875 93 L 75.652344 93 Z M 75.652344 96.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 75.652344 87.179688 L 77.875 87.179688 L 77.875 83.300781 L 75.652344 83.300781 Z M 75.652344 87.179688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 75.652344 77.484375 L 77.875 77.484375 L 77.875 73.609375 L 75.652344 73.609375 Z M 75.652344 77.484375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 75.652344 67.796875 L 77.875 67.796875 L 77.875 63.917969 L 75.652344 63.917969 Z M 75.652344 67.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 75.652344 58.101563 L 77.875 58.101563 L 77.875 54.226563 L 75.652344 54.226563 Z M 75.652344 58.101563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 75.652344 48.410156 L 77.875 48.410156 L 77.875 44.53125 L 75.652344 44.53125 Z M 75.652344 48.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 75.652344 29.027344 L 77.875 29.027344 L 77.875 25.152344 L 75.652344 25.152344 Z M 75.652344 29.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 75.652344 39.390625 L 77.875 39.390625 L 77.875 35.511719 L 75.652344 35.511719 Z M 75.652344 39.390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 77.929688 91.3125 L 80.683594 91.3125 L 80.683594 89.375 L 77.929688 89.375 Z M 77.929688 91.3125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 66.800781 91.3125 L 71.253906 91.3125 L 71.253906 89.375 L 66.800781 89.375 Z M 66.800781 91.3125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 55.664063 91.3125 L 60.121094 91.3125 L 60.121094 89.375 L 55.664063 89.375 Z M 55.664063 91.3125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 44.53125 91.3125 L 48.980469 91.3125 L 48.980469 89.375 L 44.53125 89.375 Z M 44.53125 91.3125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 33.402344 91.3125 L 37.851563 91.3125 L 37.851563 89.375 L 33.402344 89.375 Z M 33.402344 91.3125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 22.261719 91.3125 L 26.71875 91.3125 L 26.71875 89.375 L 22.261719 89.375 Z M 22.261719 91.3125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 14.363281 91.3125 L 11.132813 91.3125 L 11.132813 89.375 L 14.363281 89.375 L 14.363281 87.847656 L 16.585938 87.847656 L 16.585938 91.722656 L 14.363281 91.722656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 0 91.3125 L 4.449219 91.3125 L 4.449219 89.375 L 0 89.375 Z M 0 91.3125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 136.636719 148.101563 L 141.089844 148.101563 L 141.089844 146.160156 L 136.636719 146.160156 Z M 136.636719 148.101563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 125.507813 148.101563 L 129.960938 148.101563 L 129.960938 146.160156 L 125.507813 146.160156 Z M 125.507813 148.101563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 114.375 148.101563 L 118.824219 148.101563 L 118.824219 146.160156 L 114.375 146.160156 Z M 114.375 148.101563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 103.234375 148.101563 L 107.6875 148.101563 L 107.6875 146.160156 L 103.234375 146.160156 Z M 103.234375 148.101563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 92.105469 148.101563 L 96.558594 148.101563 L 96.558594 146.160156 L 92.105469 146.160156 Z M 92.105469 148.101563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 80.972656 148.101563 L 85.425781 148.101563 L 85.425781 146.160156 L 80.972656 146.160156 Z M 80.972656 148.101563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 69.84375 148.101563 L 74.292969 148.101563 L 74.292969 146.160156 L 69.84375 146.160156 Z M 69.84375 148.101563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 58.703125 148.101563 L 63.160156 148.101563 L 63.160156 146.160156 L 58.703125 146.160156 Z M 58.703125 148.101563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 47.570313 148.101563 L 52.023438 148.101563 L 52.023438 146.160156 L 47.570313 146.160156 Z M 47.570313 148.101563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 36.441406 148.101563 L 40.894531 148.101563 L 40.894531 146.160156 L 36.441406 146.160156 Z M 36.441406 148.101563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 25.308594 148.101563 L 29.765625 148.101563 L 29.765625 146.160156 L 25.308594 146.160156 Z M 25.308594 148.101563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 18.625 146.15625 L 18.625 148.101563 L 14.363281 148.101563 L 14.363281 147.132813 L 15.472656 148.101563 L 14.363281 147.132813 L 14.363281 146 L 16.585938 146 L 16.585938 146.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 14.363281 140.179688 L 16.585938 140.179688 L 16.585938 136.304688 L 14.363281 136.304688 Z M 14.363281 140.179688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 14.363281 130.488281 L 16.585938 130.488281 L 16.585938 126.617188 L 14.363281 126.617188 Z M 14.363281 130.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 14.363281 120.796875 L 16.585938 120.796875 L 16.585938 116.925781 L 14.363281 116.925781 Z M 14.363281 120.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 14.363281 111.101563 L 16.585938 111.101563 L 16.585938 107.226563 L 14.363281 107.226563 Z M 14.363281 111.101563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 14.363281 101.414063 L 16.585938 101.414063 L 16.585938 97.542969 L 14.363281 97.542969 Z M 14.363281 101.414063 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 14.363281 82.03125 L 16.585938 82.03125 L 16.585938 78.15625 L 14.363281 78.15625 Z M 14.363281 82.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 14.363281 72.339844 L 16.585938 72.339844 L 16.585938 68.464844 L 14.363281 68.464844 Z M 14.363281 72.339844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 14.363281 62.648438 L 16.585938 62.648438 L 16.585938 58.773438 L 14.363281 58.773438 Z M 14.363281 62.648438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 14.363281 52.960938 L 16.585938 52.960938 L 16.585938 49.082031 L 14.363281 49.082031 Z M 14.363281 52.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 14.363281 43.261719 L 16.585938 43.261719 L 16.585938 39.386719 L 14.363281 39.386719 Z M 14.363281 43.261719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 16.125 35.109375 L 20.585938 35.109375 L 20.585938 33.167969 L 16.125 33.167969 Z M 16.125 35.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 27.265625 35.109375 L 31.710938 35.109375 L 31.710938 33.167969 L 27.265625 33.167969 Z M 27.265625 35.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 38.398438 35.109375 L 42.847656 35.109375 L 42.847656 33.167969 L 38.398438 33.167969 Z M 38.398438 35.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 49.527344 35.109375 L 53.980469 35.109375 L 53.980469 33.167969 L 49.527344 33.167969 Z M 49.527344 35.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 60.660156 35.109375 L 65.113281 35.109375 L 65.113281 33.167969 L 60.660156 33.167969 Z M 60.660156 35.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 70.917969 35.109375 L 75.367188 35.109375 L 75.367188 33.167969 L 70.917969 33.167969 Z M 70.917969 35.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 82.917969 35.109375 L 87.378906 35.109375 L 87.378906 33.167969 L 82.917969 33.167969 Z M 82.917969 35.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 94.058594 35.109375 L 98.507813 35.109375 L 98.507813 33.167969 L 94.058594 33.167969 Z M 94.058594 35.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 105.191406 35.109375 L 109.644531 35.109375 L 109.644531 33.167969 L 105.191406 33.167969 Z M 105.191406 35.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 116.328125 35.109375 L 120.777344 35.109375 L 120.777344 33.167969 L 116.328125 33.167969 Z M 116.328125 35.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 127.453125 35.109375 L 131.90625 35.109375 L 131.90625 33.167969 L 127.453125 33.167969 Z M 127.453125 35.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 138.589844 35.109375 L 143.042969 35.109375 L 143.042969 33.167969 L 138.589844 33.167969 Z M 138.589844 35.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 145.726563 40.515625 L 147.960938 40.515625 L 147.960938 36.640625 L 145.726563 36.640625 Z M 145.726563 40.515625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 145.726563 50.210938 L 147.960938 50.210938 L 147.960938 46.332031 L 145.726563 46.332031 Z M 145.726563 50.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 145.726563 59.902344 L 147.960938 59.902344 L 147.960938 56.03125 L 145.726563 56.03125 Z M 145.726563 59.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 145.726563 69.589844 L 147.960938 69.589844 L 147.960938 65.714844 L 145.726563 65.714844 Z M 145.726563 69.589844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 145.726563 79.289063 L 147.960938 79.289063 L 147.960938 75.414063 L 145.726563 75.414063 Z M 145.726563 79.289063 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 145.726563 88.976563 L 147.960938 88.976563 L 147.960938 85.101563 L 145.726563 85.101563 Z M 145.726563 88.976563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 145.726563 98.671875 L 147.960938 98.671875 L 147.960938 94.796875 L 145.726563 94.796875 Z M 145.726563 98.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 145.726563 108.367188 L 147.960938 108.367188 L 147.960938 104.488281 L 145.726563 104.488281 Z M 145.726563 108.367188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 145.726563 118.058594 L 147.960938 118.058594 L 147.960938 114.179688 L 145.726563 114.179688 Z M 145.726563 118.058594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 145.726563 127.75 L 147.960938 127.75 L 147.960938 123.863281 L 145.726563 123.863281 Z M 145.726563 127.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 145.726563 137.441406 L 147.960938 137.441406 L 147.960938 133.5625 L 145.726563 133.5625 Z M 145.726563 137.441406 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.89856%,10.998535%,13.699341%)",
      fillOpacity: 1
    },
    d: "M 80.683594 90.601563 L 169.214844 90.601563 L 169.214844 87.601563 L 80.683594 87.601563 Z M 80.683594 90.601563 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 131.179688 94.300781 C 128.988281 116.886719 107.242188 134.636719 80.683594 134.636719 C 52.589844 134.636719 29.925781 114.878906 29.925781 90.535156 C 29.925781 66.199219 52.589844 46.4375 80.683594 46.4375 C 87.511719 46.4375 94.027344 47.617188 99.972656 49.742188 L 99.972656 76.5 C 95.351563 71.714844 88.417969 68.679688 80.683594 68.679688 C 66.746094 68.679688 55.453125 78.425781 55.453125 90.535156 C 55.453125 102.644531 66.746094 112.394531 80.683594 112.394531 C 93.074219 112.394531 103.414063 104.597656 105.46875 94.300781 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(17.999268%,18.798828%,57.299805%)",
      fillOpacity: 1
    },
    d: "M 151.050781 150.585938 L 151.929688 150.585938 C 152.359375 150.585938 152.644531 150.535156 152.796875 150.425781 C 152.953125 150.324219 153.03125 150.179688 153.03125 150.007813 C 153.03125 149.894531 152.996094 149.789063 152.921875 149.699219 C 152.847656 149.617188 152.742188 149.539063 152.609375 149.503906 C 152.480469 149.457031 152.234375 149.441406 151.871094 149.441406 L 151.050781 149.441406 Z M 150.320313 152.738281 L 150.320313 148.917969 L 151.871094 148.917969 C 152.402344 148.917969 152.789063 148.953125 153.027344 149.023438 C 153.257813 149.09375 153.449219 149.21875 153.59375 149.394531 C 153.730469 149.570313 153.804688 149.753906 153.804688 149.953125 C 153.804688 150.238281 153.691406 150.476563 153.449219 150.683594 C 153.214844 150.894531 152.902344 151.011719 152.511719 151.03125 C 152.671875 151.089844 152.796875 151.152344 152.898438 151.230469 C 153.082031 151.382813 153.300781 151.636719 153.5625 151.992188 L 154.117188 152.738281 L 153.226563 152.738281 L 152.824219 152.136719 C 152.511719 151.664063 152.25 151.371094 152.058594 151.246094 C 151.929688 151.152344 151.734375 151.113281 151.476563 151.113281 L 151.050781 151.113281 L 151.050781 152.738281 Z M 152.164063 147.816406 C 151.570313 147.816406 151 147.945313 150.4375 148.199219 C 149.882813 148.449219 149.441406 148.820313 149.128906 149.292969 C 148.808594 149.773438 148.652344 150.261719 148.652344 150.777344 C 148.652344 151.289063 148.808594 151.773438 149.117188 152.246094 C 149.429688 152.710938 149.859375 153.078125 150.421875 153.347656 C 150.972656 153.605469 151.554688 153.738281 152.164063 153.738281 C 152.765625 153.738281 153.351563 153.605469 153.902344 153.347656 C 154.46875 153.078125 154.894531 152.710938 155.203125 152.246094 C 155.511719 151.773438 155.667969 151.289063 155.667969 150.777344 C 155.667969 150.261719 155.507813 149.773438 155.195313 149.292969 C 154.878906 148.820313 154.441406 148.449219 153.878906 148.199219 C 153.324219 147.945313 152.753906 147.816406 152.164063 147.816406 M 152.164063 147.222656 C 152.867188 147.222656 153.558594 147.375 154.226563 147.6875 C 154.902344 147.988281 155.421875 148.429688 155.800781 148.996094 C 156.171875 149.5625 156.359375 150.160156 156.359375 150.777344 C 156.359375 151.382813 156.175781 151.976563 155.804688 152.542969 C 155.441406 153.101563 154.921875 153.542969 154.246094 153.851563 C 153.585938 154.167969 152.886719 154.320313 152.164063 154.320313 C 151.4375 154.320313 150.738281 154.167969 150.066406 153.851563 C 149.402344 153.542969 148.882813 153.101563 148.515625 152.542969 C 148.136719 151.976563 147.960938 151.382813 147.960938 150.777344 C 147.960938 150.160156 148.144531 149.5625 148.523438 148.996094 C 148.902344 148.429688 149.425781 147.988281 150.097656 147.6875 C 150.773438 147.375 151.460938 147.222656 152.164063 147.222656 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavlogo2);
export default __webpack_public_path__ + "static/media/navlogo2.14cf81ad6dd8ded6d9ed5d8571165062.svg";
export { ForwardRef as ReactComponent };